var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paymentTable" },
    [
      _c(
        "el-table",
        {
          key: _vm.edit,
          staticStyle: { width: "100%" },
          attrs: { data: _vm.table },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _vm.edit === ""
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "bill_no", label: "付款单号", "min-width": "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "treaty.contract_name",
              label: "合同名称",
              "min-width": "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "types", label: "业务类型", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.types === 0
                      ? _c("span", [_vm._v("回款记录")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.types === 1
                      ? _c("span", [
                          _vm._v("续费记录 - " + _vm._s(scope.row.renew.title)),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "num", label: "付款金额(元)", "min-width": "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "status", label: "发票状态", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status
                      ? _c("div", [
                          scope.row.status === -1
                            ? _c("span", { staticClass: "table-btn blue" }, [
                                _vm._v(" 开票撤回 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 0
                            ? _c("span", { staticClass: "table-btn gray" }, [
                                _vm._v(" 待开票 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 1
                            ? _c("span", { staticClass: "table-btn yellow" }, [
                                _vm._v(" 已开票 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 2
                            ? _c("span", { staticClass: "table-btn red" }, [
                                _vm._v(" 已拒绝 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 3
                            ? _c("span", { staticClass: "table-btn green" }, [
                                _vm._v(" 申请作废 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 4
                            ? _c("span", { staticClass: "table-btn red" }, [
                                _vm._v(" 同意作废 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 5
                            ? _c("span", { staticClass: "table-btn gray" }, [
                                _vm._v(" 拒绝作废 "),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 6
                            ? _c("span", { staticClass: "table-btn yellow" }, [
                                _vm._v(" 作废撤回 "),
                              ])
                            : _vm._e(),
                        ])
                      : _c("div", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "card.name", label: "创建人", "min-width": "90" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: "创建时间",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _vm.edit !== ""
            ? _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteFn(scope.row)
                                },
                              },
                            },
                            [_vm._v("移除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2654715795
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }